import { render, staticRenderFns } from "./MessageAdminPage.vue?vue&type=template&id=342d614a"
import script from "./MessageAdminPage.vue?vue&type=script&lang=js"
export * from "./MessageAdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports